// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2b08S","inner":"Form_inner__1qpDk","range":"Form_range__1bj0C","name":"Form_name__jjyal","actions":"Form_actions__37u_h"};